import { render } from "./Advertisement.vue?vue&type=template&id=89c4ac8a&scoped=true"
import script from "./Advertisement.vue?vue&type=script&lang=js"
export * from "./Advertisement.vue?vue&type=script&lang=js"

import "./Advertisement.vue?vue&type=style&index=0&id=89c4ac8a&lang=css"
import "./Advertisement.vue?vue&type=style&index=1&id=89c4ac8a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89c4ac8a"]])

export default __exports__